import { GridColDef } from "@mui/x-data-grid";
import { useEffect } from "react";
import { formatDate } from "../../helper/DateFormat";
import { CustomDataGrid } from "../../SharedComponents/CustomDataGrid/CustomDataGrid";
import { styles } from "./CustomerEngagementTable.styles";

const CustomerEngagementTable = (props: any) => {
  useEffect(() => {
    setTimeout(() => {
      const elements = document.getElementsByClassName("MuiDataGrid-virtualScroller");
      Array.from(elements).forEach(function (element) {
        element.setAttribute("tabIndex", "0");
      });
    }, 1000);
  }, []);

  const columns: GridColDef[] = [
    {
      headerName: "Title",
      field: "title",
      width: 240,
      sortable: true
    },
    {
      headerName: "Description",
      field: "description",
      width: 210,
      sortable: true
    },
    {
      headerName: "Association",
      field: "engagementAssociation",
      width: 120,
      sortable: true
    },
    {
      headerName: "Engagement Status",
      field: "engagementStatus",
      width: 220,
      sortable: true
    },
    {
      headerName: "Owner Name",
      field: "ownerName",
      width: 130,
      sortable: true
    },
    {
      headerName: "Meeting Type",
      field: "meetingType",
      width: 110,
      sortable: true
    },
    {
      headerName: "Engagement Type",
      field: "engagementType",
      width: 110,
      sortable: true
    },
    {
      headerName: "Detail Notes",
      field: "detailNotes",
      width: 120,
      sortable: true
    },
    {
      headerName: "Customer Meeting Request Notes",
      field: "customerMeetingRequestNotes",
      width: 220,
      sortable: true
    },
    {
      headerName: "Product Name",
      field: "productName",
      width: 220,
      sortable: true
    },
    {
      headerName: "created Date",
      field: "createdOn",
      type: "date",
      minWidth: 180,
      flex: 1,
      sortable: true,
      valueGetter: (value, row) => new Date(row.createdOn),
      renderCell: (params) => formatDate(params.row.createdOn)
    }
  ];

  return (
    <div className={styles.customerEngagement}>
      <CustomDataGrid
        columns={columns}
        enableUrlParams
        exportCsvButtonProps={{
          fileNamePrefix: "engagements"
        }}
        getRowId={(row) => row.engagementId}
        rows={{ values: props.tableData ?? [], count: props.tableData?.length ?? 0 }}
        showCellVerticalBorder
        kustoLink={props.kustoLink}
        TabName={`Customer View - Customer Engagements Tab - Engagements Table for ${props.tenantName}`}
      />
    </div>
  );
};

export default CustomerEngagementTable;
